<div class="toggle-visible" [style.display]="appIsHidden ? 'none' : 'block'">
    <ng-container *ngIf="{ value: state$ | async } as stateWrapper">
        <ng-container *ngIf="stateWrapper.value as state">
            <app-dev *ngIf="!production" [state]="state" [toggleKey]="'d'"></app-dev>

            <div
                [class.container-wrapper]="viewportScaling.enabled"
                [class.supervisor-mode]="
                    state.worker?.accessLevel === WorkerAccessLevel.Supervisor || state.roundState.phase === AppPhase.TableClosed
                "
                [class.online-mode]="state.configuration.tableMode === TableMode.Online"
            >
                <div
                    class="container"
                    #container
                    (window:resize)="scaleContainer($event)"
                    [style.width]="containerWidth"
                    [style.height]="containerHeight"
                >
                    <header>
                        <div class="header-content">
                            @if (state.configuration.game && state.roundState.phase !== AppPhase.TableClosed) {
                                <button
                                    class="icon icon-menu"
                                    [class.icon-menu-active]="menuVisible"
                                    (click)="menuVisible = !menuVisible"
                                ></button>

                                <div class="title">
                                    <div class="text-large" i18n>{{ state.configuration.game.displayName }}</div>
                                    <div class="text-medium">
                                        <ng-container i18n>Game ID</ng-container>: {{ state.roundState.roundId ?? '-' }} /
                                        <span class="player-count-holder"
                                            ><span class="player-count" i18n>Connected players: {{ state.playerCount || 0 }}</span></span
                                        >
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="header-content">
                            @if (
                                state.roundState.phase !== AppPhase.TableClosed ||
                                (state.worker && state.worker.accessLevel !== WorkerAccessLevel.None)
                            ) {
                                <div class="title title-align-right">
                                    <div i18n class="text-large">
                                        {{ state.worker?.name || 'Login' }}
                                    </div>
                                    <div class="text-medium">{{ time$ | async }}</div>
                                </div>
                            }
                        </div>
                    </header>
                    <div class="body">
                        <div *ngIf="menuVisible" (click)="menuVisible = false" class="menu-container">
                            <div class="menu">
                                <div class="layer layer-menu">
                                    <ul>
                                        <li>
                                            <button i18n (click)="menuVisible = false; aboutDialogVisible = true">About game</button>
                                        </li>

                                        @if (languages.length > 0) {
                                            <li i18n class="label">Languages</li>
                                            @for (language of languages; track language.code) {
                                                <li>
                                                    <button class="no-left-bg" (click)="changeLanguage(language.code)">
                                                        <span class="unicode-icon">{{ language.flagSymbol }}</span
                                                        ><span i18n>{{ language.label }} </span>
                                                    </button>
                                                </li>
                                            }
                                        }
                                    </ul>
                                </div>

                                <div class="layer layer-overlay"></div>
                            </div>
                        </div>

                        <div
                            class="main-area"
                            [class.main-area-when-sidebar-open]="
                                state.configuration.tableMode === TableMode.Online &&
                                state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                state.roundState.phase !== AppPhase.TableClosed
                            "
                        >
                            @if (
                                state.supervisorState && state.supervisorState.subPhase === SupervisorSubPhase.GameSelection && state.games
                            ) {
                                @if (state.roundState.phase === AppPhase.TableClosed) {
                                    @if (false && state.games.unfinishedGame) {
                                        <app-game-selection
                                            [title]="'Finish game'"
                                            [games]="[state.games.unfinishedGame]"
                                            (gameSelected)="selectGame($event, { isUnfinished: true })"
                                            [showBackButton]="false"
                                        />
                                    } @else {
                                        <app-game-selection
                                            [games]="state.games.availableGames"
                                            (gameSelected)="selectGame($event)"
                                            [showBackButton]="false"
                                        />
                                    }
                                } @else {
                                    <app-game-selection
                                        [games]="state.games.availableGames"
                                        [currentGameId]="state.configuration.game?.id"
                                        (gameSelected)="selectGame($event)"
                                        (backClicked)="cancelSupervisorAction()"
                                    />
                                }
                            } @else {
                                @if (
                                    state.roundState.phase === AppPhase.TableClosed &&
                                    state.worker?.accessLevel !== WorkerAccessLevel.Supervisor
                                ) {
                                    <app-supervisor-panel [message]="'Scan supervisor card to open table'" [showBackButton]="false" />
                                } @else {
                                    <app-supervisor-confirm-panels
                                        [supervisorState]="state.supervisorState"
                                        [currentGame]="state.configuration.game"
                                        (cancelActionClicked)="cancelSupervisorAction()"
                                    />
                                }
                            }

                            <main>
                                <app-modal *ngIf="aboutDialogVisible" (closeClicked)="aboutDialogVisible = false">
                                    <app-about [backendVersion]="state.configuration.appVersion" [frontendVersion]="version"></app-about>
                                </app-modal>
                                <app-error-panel
                                    *ngIf="state.roundState?.phase === AppPhase.RoundError"
                                    [errorCode]="state.roundState.errorCode"
                                ></app-error-panel>
                                <app-waiting-for-croupier
                                    *ngIf="state.roundState?.phase === AppPhase.WaitingForCroupier"
                                ></app-waiting-for-croupier>
                                <app-waiting-for-players
                                    *ngIf="state.roundState?.phase === AppPhase.WaitingForPlayers"
                                ></app-waiting-for-players>
                                <app-round-voided *ngIf="state.roundState?.phase === AppPhase.RoundVoid"></app-round-voided>
                                <app-shoe-change *ngIf="state.roundState?.phase === AppPhase.ShoeChange"></app-shoe-change>
                                <app-burn-cards
                                    *ngIf="state.roundState?.phase === AppPhase.CardBurn"
                                    [cardValue]="state.shoeChangeState?.card"
                                    [totalToBurnCount]="state.shoeChangeState?.totalToBurnCount ?? 0"
                                    [burnedCardsCount]="state.shoeChangeState?.burnedCount || 0"
                                ></app-burn-cards>
                                <app-new-round-preparation
                                    *ngIf="state.roundState?.phase === AppPhase.NewRoundPreparation"
                                ></app-new-round-preparation>
                                <app-bets-status
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsOpen"
                                    i18n
                                    [initialTimeInSeconds]="
                                        state.roundState.remainingBettingTimeInSeconds ?? state.configuration.bettingWindowInSeconds
                                    "
                                    >Bets are open
                                </app-bets-status>
                                <app-bets-status
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsClosed"
                                    i18n
                                    [animate]="false"
                                    [initialTimeInSeconds]="0"
                                    >Bets are closed
                                </app-bets-status>
                                <app-game-switch
                                    *ngIf="state.configuration.game"
                                    [gameType]="state.configuration.game.gameType"
                                    [tableUpdate]="state.tableUpdate"
                                    [gameResultChange]="state.gameResultChange"
                                    [appPhase]="state.roundState.phase"
                                    [subPhase]="state.roundState.subPhase"
                                >
                                    <app-result-change
                                        result-change
                                        *ngIf="
                                            state.supervisorState?.selectedAction === SupervisorAction.ChangeResult &&
                                            !state.supervisorState?.changedGameResult
                                        "
                                        (resultChangeConfirmed)="confirmResultChange($event)"
                                        (resultChangeClosed)="cancelSupervisorAction()"
                                    ></app-result-change>
                                    <app-count-down
                                        count-down
                                        *ngIf="state?.roundState?.phase === AppPhase.Decision"
                                        [initialTimeInSeconds]="state.configuration.decisionTimeInSeconds ?? 0"
                                        [animate]="true"
                                    ></app-count-down>
                                </app-game-switch>

                                @if (dealerService.gameInProgress) {
                                    <app-cut-card *ngIf="state.shoeChangeState?.cutCardDrawn"></app-cut-card>
                                }
                            </main>

                            <app-notification
                                *ngIf="notification.visible"
                                [code]="notification.code"
                                [severity]="notification.severity"
                                [showCloseButton]="notification.showCloseButton"
                                (closeClicked)="notification.hide()"
                            ></app-notification>

                            <footer
                                [class.footer-fixed]="!dealerService.gameInProgress"
                                *ngIf="
                                    state.supervisorState?.selectedAction !== SupervisorAction.ChangeResult &&
                                    state.roundState?.phase !== AppPhase.WaitingForPlayers &&
                                    state.roundState?.phase !== AppPhase.RoundVoid
                                "
                            >
                                <div class="buttons-container">
                                    @if (
                                        state.supervisorState?.subPhase === SupervisorSubPhase.ActionSelection &&
                                        state.worker?.accessLevel === WorkerAccessLevel.Supervisor
                                    ) {
                                        <app-supervisor-actions
                                            [supervisorActions]="state.configuration.supervisorActions"
                                            [appPhase]="state.roundState.phase"
                                            [flagsState]="state.flagsState"
                                            (actionClicked)="sendSupervisorAction($event)"
                                        />
                                    } @else if (
                                        state.worker?.accessLevel === WorkerAccessLevel.Croupier ||
                                        state.roundState.phase === AppPhase.WaitingForCroupier
                                    ) {
                                        <button
                                            i18n
                                            [disabled]="state.roundState.phase === AppPhase.CardBurn"
                                            class="button-game button-game-medium"
                                            (click)="callSupervisor()"
                                        >
                                            Call supervisor
                                        </button>

                                        <button
                                            *ngIf="state.roundState?.phase === AppPhase.ShoeChange"
                                            i18n
                                            class="button-game button-game-medium button-accent"
                                            (click)="sendDealerAction(DealerAction.ShoeChanged)"
                                        >
                                            Confirm
                                        </button>

                                        @if (dealerService.gameInProgress) {
                                            <!-- `false` because not yet implemented on backend -->

                                            @if (
                                                false &&
                                                (state.roundState.phase === AppPhase.RoundEnd ||
                                                    (!state.flagsState.tableClosingRequested &&
                                                        !state.flagsState.freeHandEnabled &&
                                                        !state.flagsState.gameChangingRequested))
                                            ) {
                                                <!-- Confirm result button -->
                                                <button
                                                    i18n
                                                    class="button-game button-game-medium button-accent"
                                                    [disabled]="state.roundState.phase !== AppPhase.RoundEnd"
                                                    (click)="sendDealerAction(DealerAction.CompleteRound)"
                                                >
                                                    @if (state.flagsState.tableClosingRequested) {
                                                        Confirm Result And Close Table
                                                    } @else if (state.flagsState.gameChangingRequested) {
                                                        Confirm Result And Open New Game
                                                    } @else {
                                                        Confirm Result And Start New Hand
                                                    }
                                                </button>
                                            } @else {
                                                <!-- Supervisor action confirmed message -->
                                                @if (state.flagsState.tableClosingRequested) {
                                                    <div i18n class="button-game button-game-medium button-game-selected">
                                                        Closing table
                                                    </div>
                                                } @else if (state.flagsState.freeHandEnabled) {
                                                    <div i18n class="button-game button-game-medium button-game-selected">Freeing hand</div>
                                                } @else if (state.flagsState.gameChangingRequested) {
                                                    <div i18n class="button-game button-game-medium button-game-selected">
                                                        Changing game to {{ state.supervisorState?.selectedGame?.displayName }}
                                                    </div>
                                                }
                                            }
                                        }
                                    }
                                </div>
                            </footer>
                        </div>
                        <div
                            class="sidebar"
                            *ngIf="
                                state.configuration.tableMode === TableMode.Online &&
                                state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                state.roundState.phase !== AppPhase.TableClosed
                            "
                        >
                            <app-streaming-video
                                [videoEnabled]="!isVideoHidden"
                                [streamId]="state.configuration.videoStreamId"
                                (toggleClicked)="isVideoHidden = !isVideoHidden"
                            ></app-streaming-video>

                            <app-chat
                                [chatEnabled]="state.flagsState.chatEnabled"
                                [messages]="state.chatMessages"
                                (toggleClicked)="toggleChat(state.flagsState.chatEnabled)"
                            ></app-chat>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div *ngIf="!stateWrapper.value" class="container">
            <h2 i18n class="title-vertical-center title-white">Connecting to table…</h2>
        </div>
    </ng-container>
</div>
